import {Injectable} from '@angular/core';
import {environment} from '@env/environment';
import {HttpClient, HttpHeaders} from '@angular/common/http';


@Injectable({
    providedIn: 'root'
})
export class Globals {
    users = [];
    allAppUsers: any[] = [];
    allTags = [];
    fileName = 'ExcelSheet.xlsx';

    permittedUsers: any;

    private apiURL = environment.apiURL;


    httpOptions = {
        headers: new HttpHeaders({
            'Access-Control-Allow-Origin': '*',
            'Content-Type': 'application/json'
        })
    };


    constructor(private httpClient: HttpClient) {}

    getAllTagsForUser() {
        return this.httpClient.get<any>(this.apiURL + '/task/getAllTagsForUser');
    }

    getTags(data) {
        this.allTags = data;
    }

    getAllUsers() {
        return this.allAppUsers;
    }

    getAllActiveUsers() {
      return this.allAppUsers.filter(user => user.status === 'active' && user.id !== 2 && user.id !== 3);
    }

    setUsers(data) {
        this.users = data;
        this.allAppUsers = data;
    }

    setPermittedUsers(data) {
        this.permittedUsers = data;
    };

    getPermittedUsers() {
        return this.permittedUsers;
    };

}
